import { render, staticRenderFns, recyclableRender, components } from "./noveltOprae.vue?vue&type=template&id=214da45a&scoped=true&"
var renderjs
import script from "./noveltOprae.vue?vue&type=script&lang=js&"
export * from "./noveltOprae.vue?vue&type=script&lang=js&"
import style0 from "./noveltOprae.vue?vue&type=style&index=0&id=214da45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214da45a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/noveltyManger/noveltOprae.vue"
export default component.exports